<template>
  <div class="page-main">
    <div class="spaceBetween">
      <page-title />
      <div class="spaceRight op-btn">
        <!-- <el-button class="primary" :disabled="!(allRatio < 100)" @click="handleAdduser">
          <img src="@/assets/icons/add.png" style="width: 0.18rem" />
          <span>Add users</span>
        </el-button> -->
      </div>
    </div>
    <page-card :noHead="true" class="no-padding">
      <div slot="body" class="page-table" v-loading="loading">
        <div class="spaceBetween search-box">
          <span class="search-title"></span>
          <div class="spaceLeft search-form">
            <el-input style="margin-left: 0.1rem" class="search-input" v-model="searchAccount"
              placeholder="Enter Address to search…" @keyup.enter="getSearch" clearable @clear="getSearch">
              <el-button slot="append" size="mini" @click="getSearch">
                <svg-icon icon-class="tn-search" />
              </el-button>
            </el-input>
          </div>
        </div>

        <div class="table_box">
          <el-table :data="tableData">
            <el-table-column type="index" width="55"></el-table-column>
            <el-table-column prop="account" label="Address"></el-table-column>
            <el-table-column prop="planNames" label="Airdrop plans">
              <template slot-scope="{row}">
                {{ row.planNames.join(', ') }}
              </template>
            </el-table-column>
            <el-table-column prop="amount" label="Total UNIT">
              <template slot-scope="{row}">
                <el-tooltip :content="String(row.amount)" placement="top" effect="light">
                  <span>{{ Number(row.amount).toFixed(3) }}</span>
                </el-tooltip>
              </template>
            </el-table-column>
            <el-table-column label="Claimed UNIT">
              <template slot-scope="{row}">
                <el-tooltip :content="String(row.amounts[1])" placement="top" effect="light">
                  <span>{{ Number(row.amounts[1]).toFixed(3) }}</span>
                </el-tooltip>
              </template>
            </el-table-column>
            <el-table-column label="Remaining UNIT">
              <template slot-scope="{row}">
                <el-tooltip :content="String(row.amounts[0])" placement="top" effect="light">
                  <span>{{ Number(row.amounts[0]).toFixed(3) }}</span>
                </el-tooltip>
              </template>
            </el-table-column>
          </el-table>
        </div>
        
        <div class="pagination-container">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="pagination.page"
            :page-sizes="[10, 20, 30, 50]"
            :page-size="pagination.pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="pagination.total">
          </el-pagination>
        </div>
      </div>
    </page-card>
    <el-dialog :visible.sync="open" title="Modify Ratio" width="5rem" center :close-on-click-modal="false"
      @closed="handleCancel">
      <div>
        <el-form :model="form" :rules="rules" ref="form">
          <el-form-item prop="ratio" label="Ratio">
            <el-input v-model="form.ratio" placeholder="Please fill in"></el-input>
          </el-form-item>
        </el-form>
      </div>
      <div class="dialog-footer" slot="footer">
        <el-button @click="handleCancel">Cancel</el-button>
        <el-button type="primary" :loading="btnLoading" @click="handleCheck">Submit</el-button>
      </div>
    </el-dialog>
    <el-dialog class="msgDio" :visible.sync="open2" width="5rem" center>
      <div> <b>Submit successfully！</b> </div>
      <div>Please complete the multi-signature execution as soon as possible！</div>
      <div>Proposal ID：{{ proposalId }}
        <el-button type="text" v-clipboard:copy="`${proposalId}`" v-clipboard:success="onCopy">Copy</el-button>
      </div>
    </el-dialog>
    <ErrorMsg ref="ErrorMsg"></ErrorMsg>
  </div>
</template>

<script>
import { deepClone } from "@/utils/index.js"
import BigNumber from 'bignumber.js'
import { lockedRecords } from '@/api/producer'
export default {
  data() {
    var checkRatio = (rule, value, callback) => {
      let total = new BigNumber(100)
      let chaVal = total.minus(Number(this.allRatio)).plus(Number(this.selectRow.ratio) / 1000000)
      console.log(chaVal)
      if (!value) {
        if (!(value === 0)) {
          return callback(new Error('Ratio cannot be empty'));
        }
      }
      let reg = /^(?=.*[0-9])\d{0,3}(?:\.\d{0,6})?$/
      if (!reg.test(value)) {
        return callback(new Error(`Please enter an integer or a decimal with no more than 6 decimal places`));
      }
      if (Number(value) > chaVal || Number(value) < 0) {
        return callback(new Error(`Please enter a number between 0 and ${chaVal}`));
      }
    };
    return {
      loading: false,
      btnLoading: false,
      contract: null,
      contractAddress: null,
      tableData: [],
      allTableData: [],
      allRatio: null,
      searchAccount: null,
      open: false,
      form: {},
      selectRow: {},
      rules: {
        ratio: [
          { validator: checkRatio, trigger: 'blur' }
        ]
      },
      proposalId: null,
      open2: false,
      pagination: {
        page: 1,
        pageSize: 20,
        total: 0
      }
    };
  },
  async mounted() {
    // let res = await this.getAbi('AirDrop')
    // let myAddress = process.env.VUE_APP_CONTRACT_ADDRESS ? process.env.VUE_APP_CONTRACT_ADDRESS : res.result.address
    // this.contract = new web3.eth.Contract(res.result.abi, myAddress);
    // this.contractAddress = myAddress;
    await this.getList();
  },
  methods: {
    async getList() {
      try {
        this.loading = true;
        let res = await lockedRecords({
          account: this.searchAccount,
          page: this.pagination.page,
          pageSize: this.pagination.pageSize
        })
        console.log('lockedRecords', res)
        if (res.code === 0 && res.data) {
          this.tableData = res.data.list || []
          this.pagination.total = res.data.total || 0
          this.pagination.page = res.data.page || 1
          this.pagination.pageSize = res.data.pageSize || 20
        } else {
          this.$message.error('Failed to get data')
        }
        this.loading = false
      } catch (err) {
        console.log(err);
        this.loading = false
        this.$message.error('Failed to get data')
      }
    },
    handleSizeChange(size) {
      this.pagination.pageSize = size
      this.getList()
    },
    handleCurrentChange(page) {
      this.pagination.page = page
      this.getList()
    },
    objUnique(arr) {
      const res = new Map();
      return arr.filter(arr => !res.has(arr.account) && res.set(arr.account, 1));
    },
    async getSearch() {
      this.pagination.page = 1
      await this.getList()
    },
    handleAdduser() {
      this.$router.push({
        path: "/addPage",
        query: {
          allRatio: this.allRatio
        }
      });
    },
    handleEdit(row) {
      this.selectRow = deepClone(row)
      this.form = deepClone(row)
      this.form.ratio = this.form.ratio / 1000000
      this.open = true
    },
    handleCancel() {
      this.$refs['form'].resetFields();
      this.open = false
      this.form = {}
    },
    handleCheck() {
      let flag = true
      this.$refs['form'].validateField('ratio', (valid) => {
        if (valid) flag = false
      });
      if (flag) this.handleSubmit()
    },
    handleSubmit() {
      let r = new BigNumber(this.form.ratio)
      let rVal = r.multipliedBy(1000000).toString()
      this.btnLoading = true
      const tx_builder = this.contract.methods["propose"](
        0,
        [this.form.account],
        [rVal]
      );
      const encoded_tx = tx_builder.encodeABI();

      let json = {
        gas: this.$store.getters.gas,
        from: this.$store.getters.metaMaskObj.account,
        to: this.contractAddress,
        value: 0,
        data: encoded_tx,
      };
      web3.eth
        .sendTransaction(json)
        .then((res) => {
          setTimeout(this.getProposalId(res.blockNumber), 10000)
        })
        .catch((error) => {
          console.error(error);
          if (error.code === 4001) {
            this.$message.error(error.message)
          } else {
            this.$refs.ErrorMsg.show(error.receipt.blockNumber)
          }
          this.btnLoading = false;
        });
    },
    async getProposalId(blockNumber) {
      try {
        const arr = await this.contract.getPastEvents('SendProposal', {
          fromBlock: blockNumber,
          toBlock: blockNumber
        });
        arr.forEach(item => {
          if (item.returnValues.proposer.toLowerCase() === this.$store.getters.metaMaskObj.account.toLowerCase()) {
            this.proposalId = item.returnValues.proposalId
          }
        })
        this.btnLoading = false;
        this.handleCancel()
        this.open2 = true
      }
      catch (error) {
        console.error(error)
        if (error.code === 4001) {
          this.$message.error(error.message)
        } else {
          this.$refs.ErrorMsg.show(error.receipt.blockNumber)
        }
        this.btnLoading = false;
      }
    },
    onCopy() {
      this.$message.success('Copy successfully!')
    }
  },
};
</script>
<style scoped lang="scss">
.msgDio {

  /deep/ .el-dialog__header {
    border-bottom: 0;
  }

  div {
    text-align: center;
    line-height: 30px;
  }
}

.op-btn {
  margin-bottom: 0.24rem;

  .el-button {
    padding: 0.12rem 0.16rem;
    font-size: 0.18rem;
    line-height: 0.2rem;
    color: #626871;
    border-color: #d9dde3;
    background: #fff;

    &.primary {
      background: linear-gradient(264deg, #225bfc 0%, #062567 100%);
      border-color: transparent;
      color: #fff;
    }
  }
}

.page-table {
  .text-blue {
    color: #225bfc;
    margin-right: 0.12rem;
  }

  .text-orange {
    color: #f58000;
    margin-right: 0.12rem;
  }
}

.search-box {
  padding: 0.24rem 0.32rem;
  border-bottom: 1px solid #f0f0f0;

  .search-title {
    font-size: 0.22rem;
    font-weight: bold;
  }

  .search-item {
    margin-left: 0.24rem;
  }
}

.pagination-container {
  padding: 0.2rem;
  text-align: right;
  .el-pagination{
    bottom: 0;
  }
}
</style>
